import React from 'react';
import AppsIcon from '@material-ui/icons/Apps';

const Apps = (props) => <AppsIcon {...props} />;

export default Apps;
